/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Reject_MemberInputs */

const en_admin_membership_confirmations_reject_member = /** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject Member`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const de_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const es_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const fr_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const it_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const pl_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const hu_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/** @type {(inputs: Admin_Membership_Confirmations_Reject_MemberInputs) => LocalizedString} */
const ro_admin_membership_confirmations_reject_member = en_admin_membership_confirmations_reject_member;

/**
* | output |
* | --- |
* | "Reject Member" |
*
* @param {Admin_Membership_Confirmations_Reject_MemberInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_reject_member = /** @type {((inputs?: Admin_Membership_Confirmations_Reject_MemberInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Reject_MemberInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_reject_member(inputs)
	if (locale === "de") return de_admin_membership_confirmations_reject_member(inputs)
	if (locale === "es") return es_admin_membership_confirmations_reject_member(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_reject_member(inputs)
	if (locale === "it") return it_admin_membership_confirmations_reject_member(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_reject_member(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_reject_member(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_reject_member(inputs)
	return ro_admin_membership_confirmations_reject_member(inputs)
});
export { admin_membership_confirmations_reject_member as "admin.membership_confirmations.reject_member" }